import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./page-header.templates";

export default {
    title: "Salesforce/Components/Page Header",
    component: "ux-iws-sf-page-header",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        endpoint: "https://www.trumpf.com/api/default/menu/1.0/main-menu",
        locale: "de_DE",
        homeLinkUrl: "https://www.trumpf.com/de_DE/",
        homeLinkText: "Zu trumpf.com",
        logoLinkUrl: "/",
        profileLinkText: "John Doe",
    },
};

export const Default = {};
